import classNames from 'classnames';

const Check = ({ ariaHidden = true, className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    className={classNames('icon', className)}
    role="presentation"
    aria-hidden={ariaHidden}
  >
    <title>Check</title>
    <g fillRule="evenodd">
      <path
        fill="currentColor"
        d="M4.70710654,12.2928929 C4.31658225,11.9023686 3.68341727,11.9023686 3.29289298,12.2928929 C2.90236869,12.6834172 2.90236869,13.3165821 3.29289298,13.7071064 L8.29289298,18.7071064 C8.68341727,19.0976307 9.31658225,19.0976307 9.70710654,18.7071064 L20.7071065,7.70710642 C21.0976308,7.31658213 21.0976308,6.68341715 20.7071065,6.29289286 C20.3165822,5.90236857 19.6834173,5.90236857 19.292893,6.29289286 L8.99999976,16.5857861 L4.70710654,12.2928929 Z"
      />
    </g>
  </svg>
);

Check.propTypes = {
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
};

export default Check;
